<i18n src="@/locales/modules/DeviceAccessoryTranslate.json"></i18n>

<template>
	<div id="logs-todo-loading" class="vs-con-loading__container comments">
		<div class="comments__list-item">
			<div v-for="(accessory, idx) in accessories" :key="`log-todo-${idx}`" class="pb-3 ">
				<div class="flex justify-between border-solid border px-4 py-3 rounded border-gray-5 ">
					<p @click.stop="showDetail(accessory)" class="text-base	cursor-pointer">{{ accessory.name }}</p>
					<div class="flex">
						<DeviceAccessoryContextMenu
							type="vertical"
							:accessory="accessory"
							@onClickEdit="editDataAccessory"
							@onClickDelete="showDeleteAccessoryConfirm"
							@onClickCreateTodo="handleClickCreateTodoWithAccessory"
							@onClickCreateRequest="handleClickCreateRequestWithAccessory"
						/>
					</div>
				</div>
			</div>
			<div class="text-center">
				<vs-button v-if="haveMore" id="button-loadmore-accessories" :disabled="loading" class="list-item__btn-loadmore vs-con-loading__container" @click="loadMore">{{ $t("More") }}</vs-button>
			</div>
		</div>

		<AccessoryDetailDialog
			v-if="isShowAccessoryDialog"
			:accessory="accessoryDetail"
			:device="device"
			:isSidebarActive="isShowAccessoryDialog"
			@closeSidebar="toggleDetailSidebar"
			@onClickEdit="editDataAccessory"
			@onClickDelete="showDeleteAccessoryConfirm"
			@onClickCreateTodo="handleClickCreateTodoWithAccessory"
			@onClickCreateRequest="handleClickCreateRequestWithAccessory"
		/>
	</div>
</template>

<script>
import DeviceAccessoryContextMenu from "../../views/apps/cbs/device/DeviceAccessoryContextMenu";
import AccessoryDetailDialog from "./AccessoryDetailDialog";
export default {
	name: "ListDeviceAccessories",
	components: { DeviceAccessoryContextMenu, AccessoryDetailDialog },
	props: {
		type: {
			type: Number,
			required: true
		},
		device: {
			type: Object,
			required: true
		},
		accessories: {
			type: Array,
			default: () => []
		},
		totalItems: {
			type: Number,
			default: 0
		},
		limit: {
			type: Number,
			default: 5
		}
	},
	computed: {
		totalPages() {
			return Math.ceil(this.totalItems / this.limit);
		},
		haveMore() {
			if (this.page <= this.totalPages) {
				return true;
			} else {
				return false;
			}
		},
		buttonLoadMoreId() {
			if (this.type === this.$constant.ACCESSORY_TYPE.ACCESSORY) {
				return "button-loadmore-accessories";
			} else if (this.type === this.$constant.ACCESSORY_TYPE.MATERIAL) {
				return "button-loadmore-material";
			}
		}
	},
	data() {
		return {
			page: 1,
			activeForm: null,
			activePrompt: false,
			activeListForms: [],
			loading: false,
			isShowAccessoryDialog: false,
			accessoryDetail: {}
		};
	},
	methods: {
		getAccessories() {
			try {
				const payload = {
					device_id: this.device.id,
					limit: this.limit,
					page: this.page,
					type_id: this.type
				};
				this.$emit("onLoadMoreAccessories", payload);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			}
		},
		async loadMore() {
			this.$vs.loading({
				container: "#button-loadmore-accessories",
				scale: 0.6
			});
			this.loading = true;

			this.getAccessories();
		},
		finishedLoadMore() {
			this.page = this.page + 1;
			this.loading = false;
			this.$vs.loading.close("#button-loadmore-accessories > .con-vs-loading");
		},

		reloadData() {
			this.page = 1;
			this.loadMore();
		},
		editDataAccessory(accessory) {
			const data = { ...accessory, deviceId: this.device.id, accessoryType: this.type };
			this.$emit("editDataAccessory", data);
		},
		showDeleteAccessoryConfirm(accessory) {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Actions.Confirm"),
				text: this.$t("Notify.DeleteConfirm"),
				accept: () => this.deleteAccessory(accessory),
				acceptText: this.$t("Actions.Agree"),
				cancelText: this.$t("Actions.Cancel")
			});
		},
		handleClickCreateTodoWithAccessory(accessory) {
			const _accessory = { id: accessory.id, type: this.$constant.RELATION_MODELS.ACCESSORY, display_name: accessory.name };
			this.$emit("onClickCreateTodo", _accessory);
		},
		handleClickCreateRequestWithAccessory(accessory) {
			const _accessory = { id: accessory.id, type: this.$constant.RELATION_MODELS.ACCESSORY };
			this.$emit("onClickCreateRequest", _accessory);
		},
		async deleteAccessory(accessory) {
			try {
				this.$vs.loading();
				await this.$store.dispatch("deviceManagement/deleteAccessory", accessory);
				this.toggleDetailSidebar(false);
				this.$helper.notifySuccess({
					context: this,
					options: {
						text: this.$t("DeleteAccessorySuccessful", { accessoryTypeName: this.accessoryTypeName(accessory) })
					}
				});
			} catch (error) {
				console.error("Error deleteAccessory", error);
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		toggleDetailSidebar(val) {
			this.isShowAccessoryDialog = val;
		},
		showDetail(item) {
			this.accessoryDetail = item;
			this.toggleDetailSidebar(true);
		},
		accessoryTypeName(accessory) {
			switch (accessory.type_id) {
				case this.$constant.ACCESSORY_TYPE.ACCESSORY:
					return this.$t("Accessory").toLowerCase();

				case this.$constant.ACCESSORY_TYPE.MATERIAL:
					return this.$t("Material").toLowerCase();

				default:
					break;
			}
		}
	}
};
</script>
